(function () {
  function initSwatches(root) {
    root.querySelectorAll('.sst-card-swatches').forEach(function (group) {
      var card = group.closest('[data-sst-card]');
      if (!card) return;
      var img = card.querySelector('.sst-card-main-img');

      group.querySelectorAll('.sst-card-swatch').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var newSrc = btn.dataset.img;
          if (img && newSrc) {
            img.src = newSrc;
            img.srcset = newSrc;
          }
          group.querySelectorAll('.sst-card-swatch').forEach(function (b) {
            b.classList.remove('sst-card-swatch--active');
          });
          btn.classList.add('sst-card-swatch--active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSwatches(document); });
  } else {
    initSwatches(document);
  }
})();
